import { ReactiveController, ReactiveControllerHost } from 'lit';

import { State } from './state';
import { StateEvent } from './state-event';

/**
 * A reactive-controller holding a state
 */

// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
type callback = () => void | EventListener

export class StateController<T extends State>
	implements ReactiveController {

	callback: callback;
	
	constructor(
		protected host: ReactiveControllerHost,
		private readonly state: T,
		cb?: callback,
	) {
		this.host.addController(this);
		this.callback = cb || (() => this.host.requestUpdate());
	}

	hostConnected(): void {
		this.state.addEventListener(StateEvent.eventName, this.callback);
		this.callback();

	}

	hostDisconnected(): void {
		this.state.removeEventListener(StateEvent.eventName, this.callback);
	}
}
